module.exports = __webpack_public_path__ + "img/teen_resurrection.758fad8f.jpg";